export default "__VITE_ASSET__AuI8HDLT__"